import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Campaign } from '../../../../core/models/campaign/campaign';
import { DefaultLogo } from '../../../../core/services/constant';
import { CampaignInfo } from '../../../../core/models/campaign/campaign-info';
import { GtmDataLayerService } from 'src/app/core/services/gtm-data-layer.service';
@Component({
    selector: 'campaign-heading',
    templateUrl: './campaign-heading.component.html',
    styleUrls: ['./campaign-heading.component.scss'],
    standalone: false
})
export class CampaignHeadingComponent {
  defaultLogo = DefaultLogo;

  @Input() campaign: Campaign;
  @Input() campaignInfo: CampaignInfo;
  @Input() isLogin: boolean;
  @Output() saveCampaign = new EventEmitter();

  constructor(
     private _gtmDataLayerService: GtmDataLayerService,
  ) { }

  handleSaveCampaign() {
    this.saveCampaign.emit();
    }
    onShareDropdownOpen(open: boolean) {
        if (open) {
            // Use your GtmDataLayerService
            this._gtmDataLayerService.logEvent('gtm.click', { tab: 'ShareDropdown' });
        }
    }
}
